<div class="issue-card" (click)="click($event)">
  <div>
    <nb-card size="giant" class="nb-card" [nbSpinner]="loading" nbSpinnerStatus="info">
      <nb-card-header *ngIf="issue" class="nb-card-header">
        <nb-actions fullWidth>
          <nb-action class="actions">
            <a class="admin-link" [routerLink]="['/cabinet/crm/project/show/' + issue.crmProjectId]" (click)="close()">{{ issue.crmProject?.header }}</a>&nbsp;&nbsp;/&nbsp;&nbsp;

            <ng-container *ngIf="issue.parent">
              <nb-icon *ngIf="issue.parent.crmIssueType?.icon" [icon]="issue.parent.crmIssueType.icon" pack="jira" [nbTooltip]="issue.parent.crmIssueType.header" style="width: 16px; height: 16px;"></nb-icon> &nbsp;
              <a class="admin-link" [nbTooltip]="issue.parent.header" href="/cabinet/crm/project/show/{{issue.crmProject?.alias}}-{{ issue.parent.iid }}">
                {{ issue.crmProject?.alias }}-{{ issue.parent.iid }}
              </a>
              &nbsp;&nbsp;/&nbsp;&nbsp;
            </ng-container>

            <nb-icon *ngIf="issue.crmIssueType?.icon" [icon]="issue.crmIssueType.icon" pack="jira" [nbTooltip]="issue.crmIssueType.header" style="width: 16px; height: 16px;"></nb-icon> &nbsp;
            <a target="_blank" class="admin-link" nbTooltip="Редактировать" [routerLink]="getBkLink()" [queryParams]="getBkParams()">
              {{ issue.crmProject?.alias }}-{{ issue.iid }}
            </a>
            <span *ngIf="issue.hiddenForClients">
              &nbsp;&nbsp;/&nbsp;&nbsp;
              <span style="color: #c90000">
                Задача скрыта от клиентов
              </span>
            </span>
          </nb-action>
          <nb-action style="width:30px;justify-content:right;padding:0 3px" class="hide-for-client-role">
            <nb-icon icon="more-horizontal-outline" [nbContextMenu]="actions" nbContextMenuTag="context-menu"></nb-icon>
          </nb-action>
          <nb-action icon="close-outline" style="width:30px;justify-content:right;padding:0" (click)="close()"></nb-action>
        </nb-actions>
      </nb-card-header>

      <nb-card-body *ngIf="issue">
        <h5 class="title" *ngIf="!isHeaderInput" (mouseup)="showHeaderInput()">{{ issue.header }}</h5>
        <h5><input type="text" class="header-input" *ngIf="issue && isHeaderInput" [(ngModel)]="issue.header" (blur)="saveHeader()" (keyup.enter)="saveHeader()" value=""/></h5>

        <div class="container">

          <div class="row">
            <div class="col-12 col-md-8 col-lg-8" style="padding-left: 0">
              <div class="column-content">
                <nb-tabset (changeTab)="loadJobs($event)">
                  <nb-tab tabId="Info" tabTitle="Информация">

                    <nb-actions class="nb-actions">
                      <nb-action class="nb-action"
                                 nbTooltip="Добавить вложение"
                                 [nbSpinner]="uploading"
                                 (click)="uploader && uploader.selectFile()"
                      >
                        <nb-icon icon="attach"></nb-icon>
                      </nb-action>
                      <nb-action class="nb-action" *ngIf="isEpic"
                                 nbTooltip="Добавить задачу"
                                 (click)="openSubTaskLinkForm()">
                        <nb-icon icon="epictask" pack="jira"></nb-icon>
                      </nb-action>
                      <nb-action class="nb-action" *ngIf="canSubTask"
                                 nbTooltip="Добавить подзадачу"
                                 (click)="openSubTaskLinkForm()">
                        <nb-icon icon="corner-down-right-outline"></nb-icon>
                      </nb-action>
                      <nb-action class="nb-action"
                                 nbTooltip="Добавить ссылку">
                        <nb-icon icon="link" pack="jira" [nbContextMenu]="linkActions"
                                 nbContextMenuTag="link-context-menu"></nb-icon>
                      </nb-action>
                      <nb-action class="nb-action"
                                 nbTooltip="Добавить список"
                                 (click)="openIssueCheckbox()">
                        <nb-icon icon="checkmark-square-outline"></nb-icon>
                      </nb-action>
                    </nb-actions>

                    <div class="web-links-container">
                      <div class="web-links-header">
                        <strong>Описание</strong>
                        <nb-icon (click)="showForm = true" icon="edit-outline"></nb-icon>
                      </div>
                      <div class="content-box" [ngSwitch]="showForm">
                        <ng-template [ngSwitchCase]="true">
                          <app-rich-text [control]="issueControl" [showForm]="true" (doSave)="save()" (doCancel)="showForm = false"></app-rich-text>
                        </ng-template>
                        <ng-template [ngSwitchCase]="false">
                          <app-rich-text [html]="issue.content"></app-rich-text>
                        </ng-template>
                      </div>
                    </div>

                    <div class="web-links-container">
                      <div class="web-links-header">
                        <strong>Вложения</strong>
                        <nb-icon [nbSpinner]="uploading" (click)="uploader && uploader.selectFile()" icon="plus-circle-outline"></nb-icon>
                      </div>
                      <app-uploaad #uploader [issue]="issue" (onBeginUpload)="uploading = true" (onDone)="uploading = false"></app-uploaad>
                    </div>

                    <div #subTaskLinks>
                      <app-subtask-links-issue [issue]="issue" [showForm]="showSubTaskLinkForm"></app-subtask-links-issue>
                    </div>

                    <div #taskLinks>
                      <app-task-links-issue [issue]="issue" [showForm]="showTaskLinkForm"></app-task-links-issue>
                    </div>

                    <div #webLinks>
                      <app-web-links-issue [issue]="issue" [showForm]="showWebLinkForm"></app-web-links-issue>
                    </div>

                    <div #issueCheckList>
                      <app-issue-checklist [issue]="issue" [add]="showIssueChecklist" [showComponent]="showIssueChecklist"></app-issue-checklist>
                    </div>

                    <app-comment-issue [issue]="issue"></app-comment-issue>

                  </nb-tab>
                  <nb-tab tabId="Jobs" tabTitle="Логирование времени" *ngIf="!isClientRole() && columns">
                    <ngx-table #table class="report-table hide-pager"
                               [configuration]="jobsConfiguration"
                               [columns]="jobColumns"
                               [data]="jobs$ | async"
                    >
                    </ngx-table>
                  </nb-tab>
                </nb-tabset>
              </div>
            </div>
            <div class="col-12 col-md-4 col-lg-4 column-scroll">
              <div class="column-content">

                <div class="issue-left-column-item member">
                  <div class="issue-left-column-item-title">Колонка</div>
                  <nb-select hero size="small" status="primary" [(selected)]="selectedColumn" (selectedChange)="changeColumn($event)" placeholder="Выберите колонку">
                    <nb-option *ngFor="let column of columns" [value]="column.id" [disabled]="column.id === selectedColumn">{{ column.header }}</nb-option>
                  </nb-select>
                </div>

                <div class="issue-left-column-item member" *ngIf="!isClientRole()">
                  <div class="issue-left-column-item-title">{{ translations.estimate }}</div>
                  <app-issue-estimate [value]="issue.estimate" (update)="onChangeEstimate($event)"></app-issue-estimate>
                </div>

                <div class="issue-left-column-item fc member">
                  <div class="issue-left-column-item-title">{{ translations.estimateForClient }}</div>
                  <app-issue-estimate [value]="issue.estimateForClient" (update)="onChangeEstimateForClient($event)" [readOnly]="isClientRole()"></app-issue-estimate>
                </div>

                <div class="issue-left-column-item member" *ngIf="!isClientRole()">
                  <div class="issue-left-column-item-title">Затрачено</div>
                  <div style="padding-left:8px"><strong>{{ formatDuration(issue.spent) }}</strong></div>
                </div>

                <div class="issue-left-column-item member">
                  <div class="issue-left-column-item-title">Дата создания</div>
                  <div style="padding-left:8px"><strong>{{ issue.createdAt | date: "d MMM YYYY" }}</strong></div>
                </div>

                <div class="issue-left-column-item member">
                  <div class="issue-left-column-item-title">Крайний срок</div>
                  <app-issue-due-date [issue]="issue" (updateDueDateEvent)="onChangeDueDate($event)"></app-issue-due-date>
                </div>

                <div class="issue-left-column-item member" *ngIf="issue.releasedAt">
                  <div class="issue-left-column-item-title">{{ translations.releasedAt }}</div>
                  <span style="padding: 8px">{{ issue.releasedAt | date: "d MMM YYYY" }}</span>
                </div>

                <div class="issue-left-column-item member" *ngIf="!isSubTask">
                  <div class="issue-left-column-item-title">Эпик</div>
                  <app-issue-epic-link [issue]="issue"
                                       (updateEpicNameEvent)="onChangeEpicName($event)"
                                       (updateParentEvent)="onUpdateParent($event)">
                  </app-issue-epic-link>
                </div>

                <div class="issue-left-column-item member">
                  <div class="issue-left-column-item-title">Приоритет</div>
                  <app-issue-tag [issue]="issue" [canEdit]="true" (changeTag)="onChangeTag($event)"></app-issue-tag>
                </div>

                <div class="issue-left-column-item member" *ngIf="!isClientRole()">
                  <div class="issue-left-column-item-title">Подпроект</div>
                  <span *ngIf="canChangePayment()">
                    <app-payment-autocomplete [issue]="issue" [unclosed]="true" (selectedPaymentEvent)="onChangePayment($event)">
                    </app-payment-autocomplete>
                  </span>
                  <span *ngIf="!canChangePayment()" style="padding: 0 8px">
                      {{ issue.subproject.header }}

                    <nb-icon icon="question-mark" [nbTooltip]="translations.paymentClosedChange"></nb-icon>
                        </span>
                </div>

                  <div class="issue-left-column-item member" *ngIf="!isClientRole()">
                    <div class="issue-left-column-item-title">Среда</div>
                    <app-issue-environment [issue]="issue" (changeEnvironment)="onChangeEnvironment($event)"></app-issue-environment>
                  </div>
                  <div class="issue-left-column-item member" *ngIf="!isClientRole() || isClientCamozzi()">
                    <div class="issue-left-column-item-title">Исполнитель</div>
                    <app-executor-autocomplete [issue]="issue"
                                               (selectedAssigneeEvent)="onChangeAssignee($event)"></app-executor-autocomplete>
                  </div>
                  <div class="issue-left-column-item member" *ngIf="!isClientRole()">
                    <div class="issue-left-column-item-title">Команда</div>
                    <app-executor-multiple-autocomplete
                      [initialEntities]="issue.relatedPersons"
                      [excludeEntity]="issue.assignee"
                      (changeEvent)="onChangeRelatedPersons($event)"></app-executor-multiple-autocomplete>
                  </div>
                <div class="issue-left-column-item member">
                  <div class="issue-left-column-item-title">Автор</div>

                  <nb-user [showInitials]="issue.author.picture === null" size="small" color="rgba(9, 30, 66, 0.04)"
                           style="margin-left: 3px"
                           [name]="issue.author?.firstName + ' ' + issue.author?.lastName"
                           [picture]="getImageUri( issue.author.picture)">
                  </nb-user>

                </div>

                <ng-container *ngIf="(terms$ | async) as terms">
                  <br>
                  <div *ngIf="terms.length">
                    <nb-tag-list>
                      <nb-tag status="basic" *ngFor="let term of terms" [text]="term.header"></nb-tag>
                    </nb-tag-list>
                  </div>
                </ng-container>

                <ng-container *nbIsGranted="['view', 'issue-activity-log']">
                  <nb-accordion multi class="nb-accordion" *ngIf="allLogs.length > 0">
                    <nb-accordion-item class="nb-accordion-item">
                      <nb-accordion-item-header>
                        Лог событий по задаче
                      </nb-accordion-item-header>
                      <nb-accordion-item-body class="nb-accordion-item-body">
                        <app-issue-activity-logs [allLogs]="allLogs"></app-issue-activity-logs>
                      </nb-accordion-item-body>
                    </nb-accordion-item>
                  </nb-accordion>
                </ng-container>


                <nb-accordion multi class="nb-accordion" *ngIf="(merges$ | async)?.length">
                  <nb-accordion-item class="nb-accordion-item">
                    <nb-accordion-item-header>
                      Запросы на слияние
                    </nb-accordion-item-header>
                    <nb-accordion-item-body class="nb-accordion-item-body">
                      <div class="issue-left-column-item-text" *ngFor="let merge of merges$ | async">
                        <nb-icon [nbTooltip]="merge.merged ? 'Слито' : 'Еще не слито'" [icon]="merge.merged ? 'checkmark-outline' : 'loader-outline'"></nb-icon>
                        <span nbTooltip="{{merge.author?.firstName}} {{merge.author?.lastName}} {{merge.createdAt |  date}}">{{ merge.header }}</span>
                      </div>
                    </nb-accordion-item-body>
                  </nb-accordion-item>
                </nb-accordion>

              </div>
            </div>
          </div>
        </div>

      </nb-card-body>
    </nb-card>
  </div>
</div>

<ng-template #assigneeTpl let-job>
  <nb-user color="rgba(9, 30, 66, 0.04)" size="small"
           nbPrefix
           [showInitials]="job.assignee.avatar === null"
           [name]="job.assignee.name"
           [picture]="getImageUri(job.assignee.avatar)">
  </nb-user>
</ng-template>

<ng-template #startTime let-job>
  {{ getShiftedTimeForOutput(job.startAt) | date: "dd MMMM YYYY, HH:mm" }}
</ng-template>

<ng-template #spent let-job>
  <strong>{{ formatDuration(job.spent) }}</strong>
</ng-template>

<image-preview
  #preview
  [title]="issue.crmProject?.alias + '-' + issue.iid + ' ' + issue.header"
  *ngIf="issue"
/>
